import { CountryDto } from "./country-dto.model";
import { CustomerServiceDto } from "./customer-service-dto.model";
import { PickListDto } from "./pick-list-dto.model";
import { ProductDto } from "./product-dto.model";
import { ShippingDto } from "./shipping-dto.model";
import { UserFaxDto } from "./user-fax-dto.model";

export class ReferenceDto {
  pickListDtos: PickListDto[] = [];
  productDtos: ProductDto[] = [];
  countryDtos: CountryDto[] = [];
  shippingDtos: ShippingDto[] = [];
  customerServiceDtos: CustomerServiceDto[] = [];
  userFaxDtos: UserFaxDto[] = [];
}
